<template>
  <layout>
    <page-header :actions="actions" :header="$t('companies.title')" />
    <div class="content">
      <admin-table v-if="currentDivision" ref="table" v-bind="tableProps">
        <template slot="name" slot-scope="{ item }">
          <div class="flex items-center company-logo">
            <img
              v-if="item.logo && item.logo.url"
              :src="item.logo.url"
              class="w-16 max-w-full mr-3"
            />
            <span>{{ item.name }}</span>
          </div>

          <div class="wrap_rating_star">
            <div class="star-rating">
              <label
                v-for="rating in ratings"
                :key="rating"
                :class="{
                  'is-selected': item.rating >= rating && item.rating !== null,
                }"
                class="star-rating__star"
                >★</label
              >
            </div>
            <span>(Reviews: {{ item.review_count }})</span>
          </div>
        </template>
      </admin-table>
    </div>
  </layout>
</template>

<script>
import { AdminTable } from 'stylemix-vue-admin'
import CompaniesApi from './Api'

const resourceBase = 'companies'

export default {
  name: 'Companies',

  components: {
    AdminTable,
  },

  data() {
    return {
      ratings: [1, 2, 3, 4, 5],
      res: 0,
      // Table resource configuration
      tableProps: {
        base: resourceBase,
        apiBuilder: () => {
          return this.api
        },
        sortBy: 'created_at',
        sortDesc: true,
        perPage: 9,
        columns: [
          {
            key: 'name',
            label: this.$t('companies.name'),
            sortable: true,
          },
          {
            key: 'email',
            label: this.$t('companies.email'),
          },
          {
            key: 'phone',
            label: this.$t('companies.phone'),
          },
          {
            key: 'drivers_count',
            label: this.$t('companies.drivers'),
            sortable: true,
          },
          {
            key: 'commission',
            label: this.$t('companies.commission'),
            sortable: true,
            formatter: value => (value ? `${value}%` : null),
          },
          {
            key: 'suspended_until',
            label: this.$t('companies.suspended_until'),
            sortable: true,
            component: 'value-date',
            config: {
              stacked: true,
            },
          },
          {
            key: 'created_at',
            label: this.$t('companies.created'),
            sortable: true,
            component: 'value-date',
            config: {
              stacked: true,
            },
          },
        ],

        // override search fields here using fields schema
        // searchFields: [
        // ],

        // define custom row actions
        // eslint-disable-next-line no-unused-vars
        rowActions: item => {
          let actions = [
            {
              label: 'Commissions',
              variant: 'light',
              handler: () => {
                this.$router.push({
                  name: `${resourceBase}.commissions`,
                  params: { id: item.id },
                })
              },
            },
          ]

          if (
            this.$allows(`${resourceBase}.update`) ||
            this.$allows(`${resourceBase}.view`)
          ) {
            actions.push('edit')
          }
          if (this.$allows(`${resourceBase}.delete`)) {
            actions.push('delete')
          }

          if (item.suspended_until && this.$allows('administer')) {
            actions.push({
              label: 'Unsuspend',
              variant: 'success',
              handler: () => {
                this.res = this.api
                  .unsuspend(item.id)
                  .then(result => {
                    this.$toast.success(result.message)
                  })
                  .then(() => {
                    this.$refs.table.refresh()
                  })
              },
            })
          }

          return actions
        },

        // define custom bulk actions
        bulkActions() {
          return []
        },
      },
    }
  },

  computed: {
    // Page header actions
    actions() {
      if (this.$allows(`${resourceBase}.create`)) {
        return [
          {
            id: 'commissions',
            text: this.$t('company.commissions.title'),
            icon: 'icon-coin-dollar',
            onClick: () => {
              // eslint-disable-next-line vue/no-side-effects-in-computed-properties
              this.$router.push({
                name: `${resourceBase}.my_commissions`,
              })
            },
          },
          {
            id: 'create',
            text: this.$t('general.add_new'),
            icon: 'icon-plus-circle2',
            onClick: () => {
              // eslint-disable-next-line vue/no-side-effects-in-computed-properties
              this.$router.push({
                name: `${resourceBase}.create`,
              })
            },
          },
        ]
      } else {
        return []
      }
    },

    api() {
      return new CompaniesApi().setParameters({
        division_id: this.currentDivision.id,
      })
    },
  },

  watch: {
    currentDivision() {
      this.$refs.table && this.$refs.table.reset()
    },
  },
}
</script>
<style scoped lang="scss">
.company-logo {
  min-width: 180px;
}
</style>
